var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 54,
    viewBox: "0 0 67 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3073",
    d: "M30.8584 7.8252C30.8584 5.61606 32.6493 3.8252 34.8584 3.8252H61.1519C63.3611 3.8252 65.1519 5.61606 65.1519 7.8252V22.1168H30.8584V7.8252Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3072",
    x: 30.1133,
    y: 3.08008,
    width: 35.7846,
    height: 45.8353,
    rx: 5,
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3074",
    opacity: 0.7,
    x: 35.332,
    y: 38.4473,
    width: 25.3474,
    height: 5.23542,
    rx: 2,
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 69",
    d: "M35.332 30.9629H60.3067",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 71",
    d: "M35.332 27.1514H60.3067",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 70",
    d: "M35.332 34.5381H49.8695",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 47584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.0122 10.6581C50.4324 10.6581 50.773 10.3022 50.773 9.86322C50.773 9.42423 50.4324 9.06836 50.0122 9.06836C49.5921 9.06836 49.2515 9.42423 49.2515 9.86322C49.2515 10.3022 49.5921 10.6581 50.0122 10.6581Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.057 15.8205H44.2529C43.8784 15.8205 43.66 15.3664 43.8784 15.0746L46.7805 10.8586C46.9677 10.5992 47.3422 10.5992 47.5294 10.8586L50.4314 15.0746C50.6498 15.3989 50.4314 15.8205 50.057 15.8205Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.7,
    d: "M52.0777 15.7342H49.2212C48.7873 15.7342 48.5703 15.2628 48.7873 14.9365L50.1974 12.9422C50.4144 12.6521 50.8121 12.6521 51.0291 12.9422L52.4393 14.9365C52.7647 15.2628 52.5116 15.7342 52.0777 15.7342Z",
    fill: "#D6DCE8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 47676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47616_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3073_2",
    d: "M1.74561 7.8252C1.74561 5.61606 3.53647 3.8252 5.74561 3.8252H32.0391C34.2483 3.8252 36.0391 5.61606 36.0391 7.8252V22.1168H1.74561V7.8252Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3072_2",
    x: 1,
    y: 3.08008,
    width: 35.7846,
    height: 45.8353,
    rx: 5,
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3074_2",
    opacity: 0.7,
    x: 6.21924,
    y: 38.4473,
    width: 25.3474,
    height: 5.23542,
    rx: 2,
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 69_2",
    d: "M6.21924 30.9629H31.1939",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 71_2",
    d: "M6.21924 27.1514H31.1939",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 70_2",
    d: "M6.21924 34.5381H20.7567",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 47584_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.8936 10.6581C21.3137 10.6581 21.6543 10.3022 21.6543 9.86322C21.6543 9.42423 21.3137 9.06836 20.8936 9.06836C20.4734 9.06836 20.1328 9.42423 20.1328 9.86322C20.1328 10.3022 20.4734 10.6581 20.8936 10.6581Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.9383 15.8205H15.1342C14.7598 15.8205 14.5414 15.3664 14.7598 15.0746L17.6618 10.8586C17.849 10.5992 18.2235 10.5992 18.4107 10.8586L21.3128 15.0746C21.5312 15.3989 21.3128 15.8205 20.9383 15.8205Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.7,
    d: "M22.9585 15.7342H20.102C19.6681 15.7342 19.4512 15.2628 19.6681 14.9365L21.0783 12.9422C21.2953 12.6521 21.693 12.6521 21.9099 12.9422L23.3201 14.9365C23.6456 15.2628 23.3925 15.7342 22.9585 15.7342Z",
    fill: "#D6DCE8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 47624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47616_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3073_3",
    d: "M14.9331 5.833C14.9331 3.62386 16.724 1.83301 18.9331 1.83301H49.288C51.4972 1.83301 53.288 3.62387 53.288 5.83301V22.1949H14.9331V5.833Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3072_3",
    x: 14.0986,
    y: 1,
    width: 40.0225,
    height: 51.0228,
    rx: 5,
    fill: "white",
    stroke: "#031849",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3074_3",
    x: 19.936,
    y: 40.3682,
    width: 28.3493,
    height: 5.82795,
    rx: 2,
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 69_3",
    d: "M19.936 32.043H47.8684",
    stroke: "#031849",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 71_3",
    d: "M19.936 27.7959H47.8684",
    stroke: "#031849",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 70_3",
    d: "M19.936 36.0156H36.1952",
    stroke: "#031849",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 47584_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.4012 9.4298C36.8711 9.4298 37.252 9.03365 37.252 8.54498C37.252 8.0563 36.8711 7.66016 36.4012 7.66016C35.9312 7.66016 35.5503 8.0563 35.5503 8.54498C35.5503 9.03365 35.9312 9.4298 36.4012 9.4298Z",
    fill: "#031849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.4503 15.1755H29.9589C29.5401 15.1755 29.2958 14.6701 29.5401 14.3452L32.7858 9.65215C32.9952 9.36335 33.414 9.36335 33.6234 9.65215L36.8691 14.3452C37.1134 14.7062 36.8691 15.1755 36.4503 15.1755Z",
    fill: "#031849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.7,
    d: "M38.7099 15.0777H35.515C35.0298 15.0777 34.7871 14.553 35.0298 14.1897L36.6069 11.9697C36.8496 11.6468 37.2944 11.6468 37.5371 11.9697L39.1143 14.1897C39.4783 14.553 39.1952 15.0777 38.7099 15.0777Z",
    fill: "#031849"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.27723d0597767b5df1f1533686f63539.svg";
export { ForwardRef as ReactComponent };